export class HelpTopic {
  context: string;
  domain: string;
  key: string;
  title: string;
  devHelpText: string;
  userHelpText: string;
}
